import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../../config/URL";
import toast from "react-hot-toast";
import ImageURL from "../../../config/ImageURL";
import noImage from "../../../assets/noimage.png";

function CampaignSubmissionView() {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const getData = async () => {
        setLoading(true);
        try {
            const response = await api.get(`admin/campaign_submission/${id}`);
            setData(response.data.data);
        } catch (error) {
            toast.error("Error Fetching Data ", error);
        }
        setLoading(false);
    };

    useEffect(() => {
        getData();
    }, [id]);

    return (
        <section className="px-4">
            {loading ? (
                <div className="loader-container">
                    <div className="loader">
                        <svg viewBox="0 0 80 80">
                            <circle cx="40" cy="40" r="32"></circle>
                        </svg>
                    </div>
                </div>
            ) : (
                <>
                    <div className="card shadow border-0 mb-3">
                        <div className="row p-3">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <div>
                                    <h3 className="ls-tight">Campaign Submission</h3>
                                </div>
                                <div className="d-flex gap-3">
                                    <div>
                                        <Link to="/campaignsubmission">
                                            <button type="button" className="btn btn-light btn-sm">
                                                <span>Back</span>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container card shadow border-0" style={{ minHeight: "80vh" }}>
                        <div className="row mt-5 p-3">
                            <div className="col-md-6 col-12">
                                <div className="row mb-3">
                                    <div className="col-6 d-flex justify-content-start align-items-center">
                                        <p className="text-sm">Name</p>
                                    </div>
                                    <div className="col-6">
                                        <p className="text-muted text-sm">: {data.name || "--"}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="row mb-3">
                                    <div className="col-6 d-flex justify-content-start align-items-center">
                                        <p className="text-sm">Email</p>
                                    </div>
                                    <div className="col-6">
                                        <p className="text-muted text-sm">: {data.email || "--"}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="row mb-3">
                                    <div className="col-6 d-flex justify-content-start align-items-center">
                                        <p className="text-sm">Phone</p>
                                    </div>
                                    <div className="col-6">
                                        <p className="text-muted text-sm">: {data.phone || "--"}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="row mb-3">
                                    <div className="col-6 d-flex justify-content-start align-items-center">
                                        <p className="text-sm">Address</p>
                                    </div>
                                    <div className="col-6">
                                        <p className="text-muted text-sm">: {data.address || "--"}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="row mb-3">
                                    <div className="col-6 d-flex justify-content-start align-items-center">
                                        <p className="text-sm">Custom Value</p>
                                    </div>
                                    <div className="col-6">
                                        <p className="text-muted text-sm">: {data.custom_select_value || "--"}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="row mb-3">
                                    <div className="col-6 d-flex justify-content-start align-items-center">
                                        <p className="text-sm">Platform</p>
                                    </div>
                                    <div className="col-6">
                                        <p className="text-muted text-sm">: {data.platform || "--"}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {data.campaign ? (
                            <div className="row px-3">
                                <h5 className="mb-3">Campaign Details</h5>
                                <div className="col-md-6 col-12">
                                    <div className="row mb-3">
                                        <div className="col-6 d-flex justify-content-start align-items-center">
                                            <p className="text-sm">Title</p>
                                        </div>
                                        <div className="col-6">
                                            <p className="text-muted text-sm">: {data?.campaign?.title || "--"}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-12">
                                    <div className="row mb-3">
                                        <div className="col-6 d-flex justify-content-start align-items-center">
                                            <p className="text-sm">Image</p>
                                        </div>
                                        <div className="col-12">
                                            <img
                                                src={
                                                    data?.campaign?.image
                                                        ? `${ImageURL}${data.campaign.image}`
                                                        : noImage
                                                }
                                                alt={data?.campaign?.title || "Campaign Image"}
                                                className="img-fluid"
                                                style={{ maxHeight: "100px" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="row px-3">
                                <h5 className="mb-3">Campaign Details</h5>
                                <p className="text-muted">No Campaign Details Available.</p>
                            </div>
                        )}
                    </div>
                </>
            )}
        </section>
    );
}

export default CampaignSubmissionView;